module.exports = __webpack_public_path__ + "img/portfolio1m-m@2.9d3ba9f3.webp";